import { AbstractSearchCriteria } from './abstract-search-criteria';

export class LocationTypeSearchCriteria extends AbstractSearchCriteria {
    code: string = '';
}
